import type ServiceApi from "../../api";
import {AvmApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {ModernizationDegreeRequest, ModernizationDegreeResponse} from "../payload-types/modernization-degree";

/**
 * API-Interface für den Modernisierungsgrad (POST {@link AvmApi.PATH_MODERNIZATION_DEGREE}).
 */
export class ModernizationDegreeApiInterface extends SimpleApiInterface<ModernizationDegreeResponse> {
    constructor(
        private readonly segment: string,
        private readonly scoresAndYears: Record<string, unknown>,
        private readonly signal?: AbortSignal,
    ) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildAvmApiUrl([AvmApi.PATH_MODERNIZATION_DEGREE]);
    }

    protected buildPayload(): ModernizationDegreeRequest {
        return {segment: this.segment, ...this.scoresAndYears};
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<ModernizationDegreeResponse> {
        return executor.fetchPOST(url, credentials, this.buildPayload(), this.signal);
    }
}
